document.addEventListener("DOMContentLoaded", function () {

  const slider = document.getElementById("pmSlider");
  let slides = Array.from(slider.children);
  let index = 0;

  // Duplicate slides for infinite loop
  slides.forEach(s => slider.appendChild(s.cloneNode(true)));
  slides = Array.from(slider.children);

  function slideWidth() {
    return slides[0].offsetWidth + 25; // gap
  }

  function moveSlider() {
    slider.style.transition = "transform 0.4s ease";
    slider.style.transform = `translateX(-${index * slideWidth()}px)`;
  }

  function resetLoop() {
    if (index >= slides.length / 2) {
      slider.style.transition = "none";
      index = 0;
      slider.style.transform = `translateX(0px)`;
    }
  }

  // Next
  document.querySelector(".pm-next").addEventListener("click", () => {
    index++;
    moveSlider();
    slider.addEventListener("transitionend", resetLoop, { once: true });
  });

  // Prev (reverse loop)
  document.querySelector(".pm-prev").addEventListener("click", () => {
    index--;
    if (index < 0) index = slides.length / 2 - 1;
    moveSlider();
  });

  // Autoplay every 3 seconds
  setInterval(() => {
    index++;
    moveSlider();
    slider.addEventListener("transitionend", resetLoop, { once: true });
  }, 3000);

  // Recalculate width on resize
  window.addEventListener("resize", () => {
    slider.style.transition = "none";
    slider.style.transform = `translateX(-${index * slideWidth()}px)`;
  });

});


document.addEventListener("DOMContentLoaded", function () {

  const slider = document.getElementById("testimonialSlider");
  let slides = Array.from(slider.children);
  let index = 0;

  // Duplicate slides for infinite loop
  slides.forEach(s => slider.appendChild(s.cloneNode(true)));
  slides = Array.from(slider.children);

  function slideWidth() {
    return slides[0].offsetWidth + 25; // gap
  }

  function moveSlider() {
    slider.style.transition = "transform 0.4s ease";
    slider.style.transform = `translateX(-${index * slideWidth()}px)`;
  }

  function resetLoop() {
    if (index >= slides.length / 2) {
      slider.style.transition = "none";
      index = 0;
      slider.style.transform = `translateX(0px)`;
    }
  }

  // Next
  document.querySelector(".test-next").addEventListener("click", () => {
    index++;
    moveSlider();
    slider.addEventListener("transitionend", resetLoop, { once: true });
  });

  // Prev (reverse loop)
  document.querySelector(".test-prev").addEventListener("click", () => {
    index--;
    if (index < 0) index = slides.length / 2 - 1;
    moveSlider();
  });

  // Autoplay every 3 seconds
  setInterval(() => {
    index++;
    moveSlider();
    slider.addEventListener("transitionend", resetLoop, { once: true });
  }, 10000);

  // Recalculate width on resize
  window.addEventListener("resize", () => {
    slider.style.transition = "none";
    slider.style.transform = `translateX(-${index * slideWidth()}px)`;
  });

});



document.addEventListener("DOMContentLoaded", function () {

  const slider = document.getElementById("receipeslider");
  let slides = Array.from(slider.children);
  let index = 0;

  // Duplicate slides for infinite loop
  slides.forEach(s => slider.appendChild(s.cloneNode(true)));
  slides = Array.from(slider.children);

  function slideWidth() {
    return slides[0].offsetWidth + 25; // gap
  }

  function moveSlider() {
    slider.style.transition = "transform 0.4s ease";
    slider.style.transform = `translateX(-${index * slideWidth()}px)`;
  }

  function resetLoop() {
    if (index >= slides.length / 2) {
      slider.style.transition = "none";
      index = 0;
      slider.style.transform = `translateX(0px)`;
    }
  }

  // Next
  document.querySelector(".receipe-next").addEventListener("click", () => {
    index++;
    moveSlider();
    slider.addEventListener("transitionend", resetLoop, { once: true });
  });

  // Prev (reverse loop)
  document.querySelector(".receipe-prev").addEventListener("click", () => {
    index--;
    if (index < 0) index = slides.length / 2 - 1;
    moveSlider();
  });

  // Autoplay every 3 seconds
  // setInterval(() => {
  //   index++;
  //   moveSlider();
  //   slider.addEventListener("transitionend", resetLoop, { once: true });
  // }, 3000);

  // Recalculate width on resize
  window.addEventListener("resize", () => {
    slider.style.transition = "none";
    slider.style.transform = `translateX(-${index * slideWidth()}px)`;
  });

});


document.addEventListener("DOMContentLoaded", function () {

  const slider = document.getElementById("bannerSlider");
  let slides = Array.from(slider.children);
  let index = 0;

  // Duplicate slides for infinite loop
  slides.forEach(s => slider.appendChild(s.cloneNode(true)));
  slides = Array.from(slider.children);

  function slideWidth() {
    return slides[0].offsetWidth + 25; // gap
  }

  function moveSlider() {
    slider.style.transition = "transform 0.4s ease";
    slider.style.transform = `translateX(-${index * slideWidth()}px)`;
  }

  function resetLoop() {
    if (index >= slides.length / 2) {
      slider.style.transition = "none";
      index = 0;
      slider.style.transform = `translateX(0px)`;
    }
  }

  // Next
  document.querySelector(".banner-next").addEventListener("click", () => {
    index++;
    moveSlider();
    slider.addEventListener("transitionend", resetLoop, { once: true });
  });

  // Prev (reverse loop)
  document.querySelector(".banner-prev").addEventListener("click", () => {
    index--;
    if (index < 0) index = slides.length / 2 - 1;
    moveSlider();
  });

  // Autoplay every 3 seconds
  setInterval(() => {
    index++;
    moveSlider();
    slider.addEventListener("transitionend", resetLoop, { once: true });
  }, 3000);

  // Recalculate width on resize
  window.addEventListener("resize", () => {
    slider.style.transition = "none";
    slider.style.transform = `translateX(-${index * slideWidth()}px)`;
  });

});